import { usePageMeta } from "@/lib/meta";
import { HtmlBlock } from "@/components/HtmlBlock";
import html from "@/gen/the_thesis";

export default function ThesisPage() {
  usePageMeta("The Thesis");
  return <HtmlBlock html={html} testId="thesis-page" />;
}
